const isDescendant = (older, younger) => (
  !!older.children
  && typeof older.children !== 'function'
  && older.children.some(
    child => child === younger || isDescendant(child, younger),
  )
);

export default isDescendant;
